<div class="containers">
  <div>
    <div style="height: 500px; overflow-y: auto">
      <ag-grid-angular
        style="width: 100%; height: 100%"
        class="ag-theme-alpine"
        [rowData]="rowData"
        [animateRows]="true"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        rowSelection="multiple"
        [pagination]="true"
        [defaultColDef]="defaultColDef"
        (gridReady)="onGridReady($event)"
      >
      </ag-grid-angular>
    </div>
  </div>
  <div *ngIf="isSearched && !Activedata">
    <p style="color: rgb(215, 48, 48)">
      No data available. Please check Diffrent year or try refreshing the page.
    </p>
  </div>
</div>
<br />
